import { compact } from 'lodash';
import { split } from 'emoji-aware';

/**
 * Pluralizes a string according to the quantity param
 * @param quantity
 * @param singular
 * @param plural
 */
export const pluralize = (quantity: number, singular: string, plural: string = `${singular}s`) => {
  return quantity === 1 ? singular : plural;
};

/**
 * Adds quote marks around a string
 * @param text
 */
export const quotify = (text: string) => {
  return `“${text}”`;
};

/**
 * Oxfordifies an array of strings
 * @param list
 */
export const oxfordify = (list: string[]) => {
  const compacted = compact(list);
  const lastGroup = compacted.slice(-2);
  const rest = compacted.slice(0, -2);
  return [...rest, lastGroup.join(', and ')].join(', ');
};

/**
 * Capitalizes a string
 * @param text
 */

// export const capitalize = (text: string) => {
//   text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : text;
// };

/**
 * Capitalizes a string using a regex
 * @param text
 */

// export const capitalizeUsingRegex = (text: string) => {
//   text ? text.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase()) : text;
// };

/**
 * Converts a string to title case
 * @param text
 */
export const toTitleCase = (text: string) => {
  return text
    ? text
        .split(' ')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ')
    : text;
};

/**
 * Removes special characters from a string using a regex pattern
 * @param text
 */
export const removeSpecialCharacters = (text: string) => {
  return text ? text.replace(/[^a-zA-Z0-9_-]/g, '') : '';
};

/**
 * Generates initials from a name or email
 * @param name
 * @param email
 * @param numberOfInitials
 */
export const getInitials = (name: string, email?: string, numberOfInitials: number = 2) => {
  let initials = '?';

  if (name) {
    initials = name
      .trim()
      .toLocaleUpperCase()
      .split(/\s+/)
      .slice(0, numberOfInitials)
      .map((name) => split(name)[0])
      .join('');
  } else if (email) {
    initials = email[0].toLocaleUpperCase();
  }

  return initials;
};
